import styled from 'styled-components';
import React from 'react';
import { MessageType, EventSource } from '../../graphql/graphql';
import { MessageContent } from './MessageContent';
import { MessageIcon } from './MessageIcon';
import { useLineOfBusiness } from '../../hooks/useLineOfBusiness';
import { LineOfBusinessesBrandingColors } from '../../constants/lineOfBusinessesBrandingColors';
import { green157 } from '@spotify-internal/encore-foundation';
const MessageRowContainer = styled.span `
  width: 80%;
  display: flex;
  justify-content: ${({ isAdvisor }) => (isAdvisor ? 'start' : 'end')};

  align-self: ${({ alignStart }) => (alignStart ? 'start' : 'end')};
  gap: 0.5rem;
`;
export const MessageRow = ({ event, onAttachmentClick }) => {
    var _a, _b, _c;
    const alignStart = ((_a = event.messageEvent) === null || _a === void 0 ? void 0 : _a.messageType) === MessageType.Question ||
        event.source === EventSource.Advisor;
    const isAdvisor = event.source === EventSource.Advisor;
    const { lineOfBusiness } = useLineOfBusiness();
    const primaryMessageBubbleBackgroundColor = ((_b = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _b === void 0 ? void 0 : _b.primaryMessageBubbleBackgroundColor) || green157;
    const messageIconColor = ((_c = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _c === void 0 ? void 0 : _c.messageIconColor) ||
        green157;
    return (React.createElement(MessageRowContainer, { alignStart: alignStart, isAdvisor: isAdvisor },
        React.createElement(MessageIcon, { event: event, iconColor: messageIconColor }),
        React.createElement(MessageContent, { message: event, onAttachmentClick: onAttachmentClick, primaryBubbleBackgroundColor: primaryMessageBubbleBackgroundColor })));
};
//# sourceMappingURL=MessageRow.js.map